module.exports = "/static/assets/d458676cda22e1f03779482da4a2bdf0.png";